import hpoTermsData from '@/data/hpo-terms.json'

export interface HPOTerm {
  id: string
  name: string
  hpoCode: string
  type: 'key' | 'additional' | 'excluded'
}

export interface HPOSuggestion {
  id: string
  name: string
  hpoCode: string
  type?: 'key' | 'additional'
}

export const ALL_HPO_TERMS: HPOSuggestion[] = hpoTermsData.map((term: { id: string; name: string }) => ({
  id: term.id,
  name: term.name,
  hpoCode: term.id,
}))
